module.exports = __webpack_public_path__ + "img/selected-img.f2ec77e8.png";